import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { CopyToClipboardButton, copyToClipboardGroupKey } from '../buttons/copyToClipboardButton';
export const CellActionsWrapper = t0 => {
  const $ = _c(8);
  const {
    textToCopy,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      paddingLeft: "16px",
      position: "absolute",
      right: "0",
      top: "0",
      backgroundImage: "linear-gradient(90deg, transparent 0%, var(--cell-bg-color, var(--mui-palette-background-default)) 28%)"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== textToCopy) {
    t4 = <Box className="opacity-0 group-hover/copy:opacity-100 hover:opacity-100 transition-opacity" sx={t2}><Stack direction="row" sx={t3}><CopyToClipboardButton textToCopy={textToCopy} size="small" showOnlyOnHover={true} /></Stack></Box>;
    $[3] = textToCopy;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <Box className={copyToClipboardGroupKey} sx={t1}>{children}{t4}</Box>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};